import { cmsAxiosInstance } from '../configuration/axiosConfig';
import { ClientResponse } from '../model/ClientResponse';

export const getVyhlasenieOPristupnosti = async ():
  Promise<ClientResponse<string>> => {
  const {
    data,
    status,
  } = await cmsAxiosInstance.get(
    '/vyhlasenie-o-pristupnosti',
  );

  return {
    data: data.results[0].text,
    responseCode: status,
  };
};
